import { memo } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { PlannedDeliveryWindowsEventType } from '../../planned-delivery-windows-calendar';
import { useStores } from '../../../../../recipes';

import styles from './planned-delivery-windows-event.module.scss';

const MAX_COUNT_OF_NAMES_LIST = 3;

interface NamesLineProps {
	ids: number[] | undefined;
	getName: (id: number) => string | undefined;
	labelTranslationKey: string;
	countTranslationKey: string;
}

const NamesLine = observer(({ ids, getName, labelTranslationKey, countTranslationKey }: NamesLineProps) => {
	const { t } = useTranslation();

	if (!ids?.length) {
		return null;
	}

	const count = ids.length;

	if (count > MAX_COUNT_OF_NAMES_LIST) {
		return <span className={styles.subline}>{t(countTranslationKey, { count })}</span>;
	}

	const names = ids.map(getName).filter(Boolean);
	if (!names.length) {
		return null;
	}

	return (
		<span className={styles.subline}>
			{t(labelTranslationKey, { count: names.length, names: names.join(', ') })}
		</span>
	);
});

interface Props {
	event: PlannedDeliveryWindowsEventType;
}

const PlannedDeliveryWindowsEventRelationsName = ({ event }: Props) => {
	const { servicePlansStore, serviceArea } = useStores();

	return (
		<>
			<NamesLine
				ids={event.service_plan_ids}
				getName={id => servicePlansStore.servicePlans.get(id)?.name}
				labelTranslationKey="PLANNED_DELIVERY_WINDOWS_SLOT_CARD.SERVICE_PLAN_LABEL"
				countTranslationKey="PLANNED_DELIVERY_WINDOWS_SLOT_CARD.SERVICE_PLANS_COUNT"
			/>
			<NamesLine
				ids={event.service_area_ids}
				getName={id => serviceArea.get(id)?.name}
				labelTranslationKey="PLANNED_DELIVERY_WINDOWS_SLOT_CARD.SERVICE_AREA_LABEL"
				countTranslationKey="PLANNED_DELIVERY_WINDOWS_SLOT_CARD.SERVICE_AREAS_COUNT"
			/>
		</>
	);
};

export default memo(PlannedDeliveryWindowsEventRelationsName);
